var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlusCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.859 9c0-4.305 3.494-7.8 7.8-7.8 4.305 0 7.8 3.495 7.8 7.8s-3.495 7.8-7.8 7.8a7.803 7.803 0 0 1-7.8-7.8Zm7.8-9c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9Zm-.735 3.857v4.408H4.516v1.47h4.408v4.408h1.47V9.735h4.408v-1.47h-4.409V3.857H8.924Z",
  fill: "#4812D4"
})));
export default SvgPlusCircle;